import {customElement} from "lit/decorators.js";
import {css, html, LitElement, TemplateResult} from "lit";
import {performAction} from "../services/routeService";
import {GameState} from "@shared/types";

@customElement("start-menu")
export class StartMenu extends LitElement {
    public static styles = css`
        .start-menu {
            align-items: center;
            display: flex;
            flex-direction: column;
            height: 100vh;
            justify-content: center;
            width: 100%;
        }

        .button-container {
            display: flex;
            flex-direction: column;
            width: 40%;
        }

        .button {
            background-color: rgba(0, 0, 0, 0.5);
            border: 6px solid white;
            color: white;
            cursor: pointer;
            font-size: 30px;
            margin: 10px;
            padding: 10px 20px;
            text-transform: uppercase;
            user-select: none;
            font-family: "Onesize", sans-serif;
        }

        .button:hover {
            background-color: rgba(130, 130, 130, 0.5);
        }

        .logo {
            width: 40%;
        }

        .credits {
            border: 3px solid white;
            bottom: 0;
            font-size: 18px;
            height: 30px;
            margin: 10px;
            padding: 4px;
            position: absolute;
            right: 0;
        }

        @media (max-width: 480px) {
            body {
                background-position: left;
                background-position-x: -53px;
                background-size: cover;
            }

            .button-container {
                width: 65%;
            }

            .button {
                font-size: 15px;
                height: 40px;
                margin: 3px;
                padding: 3px 6px;
            }

            .logo {
                width: 65%;
            }

            .credits {
                font-size: 12px;
                height: 20px;
                padding: 2px;
            }
        }
    `;

    private async handleClickNewGame(): Promise<void> {
        const state : GameState | undefined = await performAction("reset-player-session");

        if (state === undefined) {
            console.error("Failed to reset player session");
        } else {
            window.location.href = "Game.html";
        }

    }

    public render(): TemplateResult {
        return html`
            <div class="start-menu">
                <img alt="Behind Closed Doors" class="logo" src="/assets/img/items/BCDW.png">
                <div class="button-container">
                    <button class="button new-game" @click=${this.handleClickNewGame}>
                        New Game
                    </button>
                    <button class="button load-game" @click=${(): string => window.location.href = "Game.html"}>
                        Load Game
                    </button>
                    <button class="button tutorial" @click=${(): string => window.location.href = "tutorial.html"}>Tutorial</button>
                </div>
            </div>
            <button class="button credits" @click=${(): string => window.location.href = "credits.html"}>Credits</button>
        `;
    }
}